// HAEVN logo wordmark — white-on-transparent.
// Use `tone="light"` (default) on light backgrounds — the image is inverted via CSS filter.
// Use `tone="dark"` on dark backgrounds (no inversion).
const LOGO_URL = "https://customer-assets.emergentagent.com/job_haevn-training/artifacts/7zvbi2q7_Asset%208-8.png";

export default function Logo({ className = "h-6", tone = "light", showSub = false, testId = "haevn-logo" }) {
    const inverted = tone === "light";
    return (
        <div className={`inline-flex items-baseline gap-2 ${showSub ? "flex-col items-start gap-0" : ""}`} data-testid={testId}>
            <img
                src={LOGO_URL}
                alt="HAEVN"
                className={`${className} w-auto select-none ${inverted ? "[filter:invert(1)]" : ""}`}
                draggable={false}
            />
            {showSub && (
                <span className={`font-editorial italic text-base mt-1 ${inverted ? "text-ink-500" : "text-white/80"}`}>
                    University
                </span>
            )}
        </div>
    );
}
